import React from "react";
import styles from "./Card.module.scss";
import classNames from "classnames";

const Card = ({ className, children, calendar }) => {
  return calendar ? (
    <div className={classNames(styles.cardContainerCalendar, className)}>
      {children}
    </div>
  ) : (
    <div className={classNames(styles.cardContainer, className)}>
      {children}
    </div>
  );
};

export default Card;
